import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotationAccepted = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 13C6.5 15.4853 8.51472 17 11 17H11.838C14.1635 17 15.3262 17 16.1769 16.2492C17.0275 15.4983 17.1555 14.4755 17.4114 12.43C17.4664 11.991 17.5 11.5853 17.5 11.25C17.5 9.42157 16.8284 9 15 9H11C8.51472 9 6.5 10.5147 6.5 13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.2 10.4L8.8344 9.46922C8.38712 9.64491 8.12806 10.1139 8.21746 10.586C8.30686 11.0582 8.71946 11.4 9.2 11.4V10.4ZM13.5 5.99999H14.5C14.5 5.51523 14.1523 5.10029 13.675 5.01543C13.1978 4.93058 12.7284 5.20026 12.5613 5.65531L13.5 5.99999ZM12.5 5.99999C12.5 6.60852 12.3312 7.49061 11.8427 8.18979C11.3927 8.83396 10.624 9.39999 9.2 9.39999V11.4C11.276 11.4 12.6573 10.516 13.4823 9.3352C14.2688 8.20938 14.5 6.89147 14.5 5.99999H12.5ZM13.5 5.99999C12.5613 5.65531 12.5614 5.65498 12.5615 5.65466C12.5616 5.65457 12.5617 5.65427 12.5617 5.65408C12.5619 5.65372 12.562 5.65341 12.5621 5.65314C12.5623 5.6526 12.5624 5.65225 12.5625 5.65209C12.5626 5.65175 12.5624 5.65216 12.562 5.65328C12.5612 5.65552 12.5592 5.66062 12.5561 5.66844C12.5499 5.68408 12.5393 5.71052 12.5239 5.74654C12.4932 5.81868 12.4439 5.92873 12.3747 6.06714C12.2359 6.34487 12.0196 6.73141 11.7155 7.15263C11.1032 8.00079 10.1681 8.94536 8.8344 9.46922L9.5656 11.3308C11.3687 10.6225 12.5836 9.36707 13.3371 8.32326C13.7159 7.7985 13.9864 7.31606 14.1637 6.96131C14.2526 6.78348 14.3187 6.63642 14.3639 6.5305C14.3865 6.4775 14.4038 6.43467 14.4162 6.4033C14.4224 6.38762 14.4274 6.37478 14.4311 6.36496C14.433 6.36005 14.4345 6.35589 14.4358 6.3525C14.4364 6.35081 14.437 6.34931 14.4375 6.348C14.4377 6.34735 14.438 6.34675 14.4382 6.34619C14.4383 6.34592 14.4384 6.34554 14.4385 6.3454C14.4386 6.34503 14.4387 6.34468 13.5 5.99999Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAnnotationAccepted);
export { ForwardRef as ReactComponent };
